/* eslint-disable @typescript-eslint/no-explicit-any */
import MainTable from "../GenericComponents/MainTable";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState } from "react";
import styles from "../../Styles/dashboard.module.css";
import AutomaticCostPage from "./AutomaticCostPage";
import { urlEnum } from "../../Utils/UrlEnum";
import { CustomerModel, PaymentModel } from "../../Utils/Models";
import { Download } from "@mui/icons-material";
import { saveAs } from "file-saver";

export default function AutomaticCosts() {
  const [open, setOpen] = useState<boolean>();
  const [item, setItem] = useState<any>();

  function handleEdit(item: any) {
    setOpen(!open);
    setItem(item);
  }

  const costsHeader = [
    {
      label: Vocabulary.type,
      name: "type",
      options: { sort: false },
    },
    {
      label: Vocabulary.date,
      name: "date",
      options: {
        sort: false,
        customBodyRender: (value: Date) => {
          return <>{value}</>;
        },
      },
    },
    {
      label: Vocabulary.description,
      name: "description",
      options: { sort: false },
    },
    {
      label: Vocabulary.vat,
      name: "payment",
      options: {
        sort: false,
        customBodyRender: (value: PaymentModel) => {
          return <>{value.tax.name}</>;
        },
      },
    },
    {
      label: Vocabulary.vendor,
      name: "vendor",
      options: {
        sort: false,
        customBodyRender: (value: CustomerModel) => {
          return <>{value.name}</>;
        },
      },
    },
    {
      label: Vocabulary.documentType,
      name: "documentType",
      options: { sort: false },
    },
    {
      label: Vocabulary.number,
      name: "number",
      options: { sort: false },
    },
  ];

  return (
    <div className={styles.mainContainerUser}>
      <MainTable
        urlEnumApi={urlEnum.anaf}
        header={costsHeader}
        tableTitle={Vocabulary.automaticList}
        handleEdit={handleEdit}
        hideOptionButtons={{
          add: true,
          delete: {
            condition: (item: any) => true,
          },
        }}
        anotherOptionButtons={[
          {
            condition: (item: any) => true,
            icon: <Download />,
            title: Vocabulary.downloadXml,
            action: (item: any) => {
              const blob = new Blob([item.file], { type: "application/xml" });
              saveAs(blob, item.xmlFileName);
            },
          },
        ]}
      />
      {open && (
        <AutomaticCostPage
          item={item}
          title={Vocabulary.automatic}
          open={open}
          onClose={() => {
            setOpen(!open);
          }}
        />
      )}
    </div>
  );
}
